import * as ActionsTypes from "../../constants/stateConstants";
import {arrayContentElementInitialState, updateState,} from "../../utils/helpers";

import * as localReferentielKeys from "../others/localReferentielKeys";

let initialState = {};

Object.values(localReferentielKeys).forEach((localReferentielKey) => {
  initialState[localReferentielKey] = arrayContentElementInitialState;
});

/*-------------------------------------------------CREATION-NOUVEAU-PACKAGE----------------------------------------------------*/
const localReferentiel = (state, { referentielKey }) => {
  return updateState(referentielKey, state, {
    ...arrayContentElementInitialState,
    isLoading: true,
  });
};

const localReferentielSuccess = (state, { referentielKey, payload }) => {
  return updateState(referentielKey, state, {
    content: payload,
    isLoading: false,
    isSuccessed: true,
  });
};

const localReferentielFail = (state, { referentielKey, payload }) => {
  return updateState(referentielKey, state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};

/*************************************************************************** */
const localReferentielReducer = (state = initialState, action) => {
  switch (action.type) {
    /*-------------------------------------------------CREATION-NOUVEAU-PACKAGE----------------------------------------------------*/
    case ActionsTypes.LOCAL_REFERENTIEL:
      return localReferentiel(state, action);
    case ActionsTypes.LOCAL_REFERENTIEL_SUCCESS:
      return localReferentielSuccess(state, action);
    case ActionsTypes.LOCAL_REFERENTIEL_FAIL:
      return localReferentielFail(state, action);
    default:
      return state;
  }
};

export default localReferentielReducer;
